import type {
    GemsApi_RangeInput,
    GemsApi_StoneFilters,
    GemsApi_StoneShape,
} from '@/graphql/api'
import type { DiamondSearchFilters } from '../../diamond'

function getDepthAndTableRanges(shape: GemsApi_StoneShape | null | undefined): {
    depth?: GemsApi_RangeInput
    table?: GemsApi_RangeInput
} {
    switch (shape) {
        case 'CUSHION':
            return {
                depth: { min: 58, max: 70 },
                table: { min: 58, max: 70 },
            }
        case 'OVAL':
            return {
                depth: { min: 56, max: 66 },
                table: { min: 52, max: 65 },
            }
        case 'EMERALD':
            return {
                depth: { min: 59, max: 70 },
                table: { min: 57, max: 72 },
            }
        case 'PEAR':
            return {
                depth: { min: 56, max: 66 },
                table: { min: 52, max: 65 },
            }
        case 'PRINCESS':
            return {
                depth: { min: 64, max: 75 },
                table: { min: 59, max: 75 },
            }
        case 'MARQUISE':
            return {
                depth: { min: 56, max: 66 },
                table: { min: 52, max: 65 },
            }
        case 'ASSCHER':
            return {
                depth: { min: 59, max: 70 },
                table: { min: 57, max: 72 },
            }
        case 'RADIANT':
            return {
                depth: { min: 59, max: 70 },
                table: { min: 57, max: 72 },
            }
        case 'HEART':
            return {
                depth: { min: 56, max: 66 },
                table: { min: 52, max: 65 },
            }
        // round is a special case
        case 'ROUND':
        // fallthrough
        default:
            return {}
    }
}

export function getCollectionOverallFilters(
    shape: GemsApi_StoneShape | null | undefined
): DiamondSearchFilters {
    if (shape === 'HEXAGONAL' || shape === 'EUROPEAN') {
        return {}
    }

    const filters: DiamondSearchFilters = {
        colour: [
            'DIAMOND_D',
            'DIAMOND_E',
            'DIAMOND_F',
            'DIAMOND_G',
            'DIAMOND_H',
        ],
        clarity: [
            'DIAMOND_FL',
            'DIAMOND_IF',
            'DIAMOND_VVS1',
            'DIAMOND_VVS2',
            'DIAMOND_VS1',
            'DIAMOND_VS2',
        ],
        polish: ['EXCELLENT', 'VERY_GOOD'],
        symmetry: ['EXCELLENT', 'VERY_GOOD'],
        fluorescence: ['NONE', 'FAINT', 'MEDIUM'],
    }

    if (shape === 'ROUND') {
        filters.cut = ['EXCELLENT']

        return filters
    }

    const ranges = getDepthAndTableRanges(shape)

    filters.depthPercent = ranges.depth
    filters.tablePercent = ranges.table

    return filters
}

export function hasFiltersThatPreventCollection(
    filters: GemsApi_StoneFilters | undefined
): boolean {
    const clone = { ...filters }

    delete clone.weight
    delete clone.priceInCurrency
    delete clone.sorting
    delete clone.isCanadaMark
    delete clone.withOriginCountry

    return Object.keys(clone).length > 0
}
